import { useMutation } from '@tanstack/react-query';
import { createApiClient } from '../api/client';
import { useAuth } from '../auth/useAuth';

export interface AiActionSubmitResult {
  jobId: string;
  status: string;
  result?: unknown;
  errorMessage?: string | null;
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

/**
 * Unified hook for executing AI actions — called by the toolbar dropdown, right-click
 * context menu, slash command menu, and modal forms. Always sends a fresh
 * Idempotency-Key so accidental re-submits dedupe server-side.
 */
export function useAIAction(slug: string) {
  const { getToken } = useAuth();
  return useMutation({
    mutationFn: async (params: Record<string, unknown>) => {
      const client = createApiClient(getToken);
      const response = await client
        .post(`api/v2/ai-actions/execute/${slug}`, {
          json: params,
          headers: { 'Idempotency-Key': crypto.randomUUID() },
          timeout: 300_000,
        })
        .json<ApiResponse<AiActionSubmitResult>>();
      return response.data;
    },
  });
}
